<template>
    <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Phrase Details
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/phrases_list">Back</router-link></li>        
        <li class="active">Add / Update Phrase</li>
      </ol>
    </section>
    <section class="content">
      <form @submit.prevent="addOrUpdate" action="#"  method="post">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Phrase Configuration</h3>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="form-group col-xs-4 col-sm-4 col-md-4">
                <div class="padding-15px">
                  <label for="name" class="required">Phrase</label>
                  <input type="text"  v-bind:class="{'form-group--error': (submitted && !$v.gRowObj.phrase.required) || phraseExistError }" v-model="gRowObj.phrase" class="form-control" id="phrase" placeholder="Phrase" />
                  <span v-if="submitted && !$v.gRowObj.phrase.required" class="text-red pull-right">Please enter phrase.</span>
                  <span v-if="submitted && phraseExistError" class="text-red pull-right">Phrase already exists.</span>
                </div>
              </div>
              <div class="form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2">
                <div class="padding-15px">
                  <label for="name" class="required">Country</label>                  
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.country_id.required }" id="country" name="country" v-model="gRowObj.country_id" @change="onChangeCountry($event)">
                      <option value=null>--Choose a Country--</option>
                      <option v-for="(data, index) in country" :key="index" :selected="data.id === gRowObj.country_id" :value="data.id">{{data.full_name}}</option>                   
                  </nv-select>
                  <span v-if="submitted && !$v.gRowObj.country_id.required" class="text-red pull-right">Please choose country.</span>
                </div>
              </div>
          </div>
           <div class="row">
            <div class="form-group col-xs-4 col-sm-4 col-md-4">
              <div class="padding-15px">
                <label for="name" class="required">Keyword</label>
                <treeselect
                  :key="keywords.length"
                  :async="true"
                  :default-options="true"
                  placeholder="--Choose a keyword--"
                  :multiple="false"
                  :load-options="loadOptions"
                  :clearable="true"
                  v-model="gRowObj.keyword_id"
                  v-bind:class="{'form-group--error': submitted && !$v.gRowObj.keyword_id.required }" />
                <span v-if="submitted && !$v.gRowObj.keyword_id.required" class="text-red pull-right">Please choose a keyword.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="row">
        </div>
        <div class="row">
          <div class="action-button">
            <button type="button" class="btn btn-primary" @click="close">Cancel</button>
            <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
          </div>
        </div>
      </form>
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import { required } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import { getSelectorValue } from '../../../utils/utilities'

  export default {
    name: 'modal',
    validations: {
      gRowObj: {
        phrase: { required },
        keyword_id: { required },
        country_id: { required }
      }
    },
    components: {
    },
    data () {
      return {
        alert: {
          show: false,
          type: '', // success, info, warning, danger
          message: ''
        },
        phraseOldName: '',
        keywordOldId: null,
        countryOldId: null,
        countryOldName: null,
        keywords: [],
        keywordCopy: [],
        loading: false,
        phraseExistError: false,
        selected: null,
        country: [],
        gRowObj: {
          id: null,
          phrase: '',
          keyword_id: null,
          country_id: null,
          createdAt: new Date()
        },
        submitted: false
      }
    },
    methods: {
      loadOptions ({ searchQuery, callback }) {
        // Only return filtered results instead of all 3000
        const results = this.keywords
          .filter(item => item.id !== this.gRowObj.keyword_id && item.label.toLowerCase().includes(searchQuery.toLowerCase()))
          .slice(0, 50) // cap results for performance

        if (this.gRowObj.keyword_id) {
          const selectedKeyword = this.keywords.find(item => item.id === this.gRowObj.keyword_id)
          if (selectedKeyword) {
            results.unshift({ id: selectedKeyword.id, label: selectedKeyword.label })
          }
        }
        results.push({
          id: '__hint__',
          label: '💡 Type keyword...',
          isDisabled: true
        })
        callback(null, results)
      },
      getCountryData () {
        api.buildRequest('getAllSupportedCountries', 'POST', {})
          .then(async (response) => {
            if (response.status === 200) {
              this.country = response.data.payload.filter(item => !(item.full_name.includes('Global') || item.full_name.includes('South Africa')))
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      loadkeywords () {
        this.loading = true
        api.buildRequest('getAllKeywords', 'POST', {isFromPhrase: true})
          .then(async (response) => {
            if (response.status === 200) {
              this.keywordCopy = response.data.payload
              this.loading = false
            }
            if (this.$route.query.phraseId) {
              this.getPhraseDetails(this.$route.query.phraseId)
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      async onChangeCountry (event) {
        // Keeping a copy for further use
        this.gRowObj.keyword_id = null
        this.keywords = []
        if (event.target.value) {
          this.keywords = this.keywordCopy.reduce((acc, k) => {
            if (k.country_id === this.gRowObj.country_id) {
              acc.push({ id: k.id, label: k.keyword })
            }
            return acc
          }, [])
        }
      },
      close () {
        this.submitted = false
        this.$router.replace('phrases_list')
      },
      async addOrUpdate (e) {
        console.log(this.$refs['client'])
        this.submitted = true
        this.phraseExistError = false
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        this.loading = true
        let queryParams = {
          selector: {
            phrase: this.gRowObj.phrase,
            country_id: this.gRowObj.country_id,
            is_deleted: false
          }
        }
        queryParams.selector = getSelectorValue(queryParams.selector)
        if (this.$route.query.phraseId && !this.$route.query.action) {
          queryParams.selector.id = this.$route.query.phraseId
        }
        api.buildRequest('/checkPhraseExists', 'POST', queryParams)
        .then(async (response) => {
          if (response.status === 200) {
            if (response.data.payload === null) {
              this.loading = true
              let trimmedObj = {}
              trimmedObj = this.trimJsonObj(this.gRowObj)
              console.log('trimmedObj')
              console.log(trimmedObj)
              const countryData = this.country.filter(item => item.id === trimmedObj.country_id)
              const countryName = countryData[0].full_name
              const newRowObj = {
                phrase: trimmedObj.phrase,
                keyword_id: trimmedObj.keyword_id,
                country_id: trimmedObj.country_id,
                coountry_name: countryName
              }
              let params = {}
              if (this.$route.query.phraseId) {
                params.updatedRow = Object.assign({}, newRowObj)
                params.updatedRow['id'] = parseInt(this.$route.query.phraseId)
                params.updatedRow.phraseOldName = this.phraseOldName
                params.updatedRow.oldKeywordId = this.keywordOldId
                params.updatedRow.oldCountryId = this.countryOldId
                params.updatedRow.countryOldName = this.countryOldName
                delete params.newRow
                this.performKeywordOperation(params, 'updatePhrase', 'Phrase added successfully.')
              } else {
                delete params.updatedRow
                params.newRow = Object.assign({}, newRowObj)
                this.performKeywordOperation(params, 'addPhrase', 'Phrase updated successfully.')
              }
            } else {
              this.phraseExistError = true
              this.loading = false
            }
          }
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      getPhraseDetails (phraseId) {
        console.log('getPhraseDetails')
        this.loading = true
        api.buildRequest('/getPhraseDetails', 'POST', { phraseId })
        .then(response => {
          if (response.status === 200) {
            const keywordDetails = response.data.payload.keywordDetails
            this.gRowObj.phrase = keywordDetails.phrase
            this.gRowObj.keyword_id = keywordDetails.keyword_id
            this.phraseOldName = keywordDetails.phrase
            this.keywordOldId = keywordDetails.keyword_id
            this.countryOldId = keywordDetails.country_id
            const countryData = this.country.filter(item => item.id === this.countryOldId)
            this.countryOldName = countryData[0].full_name
            this.gRowObj.country_id = keywordDetails.country_id || ''
            this.gRowObj.createdAt = keywordDetails.createdAt ? keywordDetails.createdAt : new Date()

            this.keywords = []
            this.keywords = this.keywordCopy.reduce((acc, k) => {
              if (k.country_id === this.gRowObj.country_id) {
                acc.push({ id: k.id, label: k.keyword })
              }
              return acc
            }, [])
            console.log('this.gRowObj')
            console.log(this.gRowObj)
          }
          this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      performKeywordOperation (params, apiToCall, message) {
        api.buildRequest(apiToCall, 'POST', params)
          .then(response => {
            if (response.status === 200) {
              if (params.updatedRow && params.updatedRow.keyword_id) {
                this.phraseOldName = params.updatedRow.phrase
                this.keywordOldId = params.updatedRow.keyword_id
                this.countryOldId = params.updatedRow.country_id
                const countryData = this.country.filter(item => item.id === this.countryOldId)
                this.countryOldName = countryData[0].full_name
              }
              this.loading = false
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : message
              })
              if (params.newRow && params.newRow.keyword_id) {
                this.submitted = false
                this.$router.replace('phrases_list')
              }
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      trimJsonObj (obj) {
        const trimmedObj = {}
        Object.keys(obj).forEach(function (key) {
          trimmedObj[key] = obj[key]
          if (obj[key] !== undefined && typeof obj[key] === 'string') {
            trimmedObj[key] = obj[key].trim()
          }
        })
        delete trimmedObj.id
        return trimmedObj
      }
    },
    async mounted () {
      console.log('route query')
      console.log(this.$route.query.phraseId)
      if (this.$route.query.phraseId && this.$route.query.action) {
        this.isEdit = false
      } else if (this.$route.query.phraseId) {
        this.isEdit = true
      } else {
        this.isEdit = false
      }
      await this.getCountryData()
      await this.loadkeywords(true)
      this.gRowObj = {
        id: null,
        phrase: '',
        keyword_id: null,
        country_id: null,
        createdAt: new Date()
      }
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
</style>


// WEBPACK FOOTER //
// PhraseDetails.vue?0acddaca